export class CamToolSlim {
  constructor(
    public hash?: string,
    public name?: string,
    public deleted?: boolean
  ) { }

  clone() {
    return new CamToolSlim (
      this.hash,
      this.name,
      this.deleted
    );
  }

  get filterableData() {
    return `${ this.name }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/cam-tool-slim.ts